import React, { Fragment, useState, useEffect, useContext } from "react";
import { H4, Btn } from "../../AbstractElements";
import {
  Container,
  Row,
  Table,
  CardFooter,
  Col,
  Card,
  CardBody,
  Form,
  Label,
} from "reactstrap";
import "rc-pagination/assets/index.css";
import "../../assets/scss/index.less";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";

import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import * as mergedQueries from "../../graphql/mergedQueries";
import { toast } from "react-toastify";
import moment from "moment";
import Button from "react-bootstrap/Button";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Pagination from "rc-pagination";
import cloneDeep from "lodash/cloneDeep";
import AWS from "aws-sdk";
import { limit, EMAIL_API } from "../../Config/Config";
import { aocontext } from "../../App";

import SPCompany from "../../Data/SPCompanyData/index";
import SiteData from "../../Data/Sites/index";
import CategoryData from "../../Data/Category/index";
import AssetTemplate from "../../Data/AssetTemplate/index";
import SiteDBData from "../../Data/DistributionBoard/index";
import axios from "axios";
import { generateClient } from "aws-amplify/api";
import base64 from "base-64";

const client = generateClient({
  headers: {
    "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
  },
});

const AddTasksContain = () => {
  AWS.config.update({
    accessKeyId: process.env.REACT_APP_ACCESSKEYID,
    secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY,
  });

  const navigate = useNavigate();
  const state = useLocation();
  const { id, view, purpose } = useParams();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [sPUser, setSPUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingRepair, setIsLoadingRepair] = useState(false);
  const [isLoadingtest, setIsLoadingtest] = useState(false);

  const LoginUserDetails = JSON.parse(
    localStorage.getItem("userDetails") || "{}",
  );
  const LoginUserGroup = localStorage.getItem("groups");

  const [RepairData, setRepairData] = useState([]);
  const [selectedTaskType, setSelectedTaskType] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const countPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPage1, setCurrentPage1] = useState(1);
  const [repairDemo, setRepairDemo] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [technician, setTechnician] = useState([]);
  const [testing, setTesting] = useState([]);
  const [testingDemo, setTestingDemo] = useState([]);
  const [assets, setAssets] = useState([]);
  const [siteDetails, setSiteDetails] = useState([]);
  const [siteFilter, setSiteFilter] = useState([]);
  const [categoryDetails, setCategoryDetails] = useState([]);
  const [siteId, setSiteId] = useState([]);
  const [catId, setCatId] = useState([]);
  const [assetSiteCat, setAssetSiteCat] = useState([]);
  const [assetSiteCatFilter, setAssetSiteCatFilter] = useState([]);
  const [selectedItemsAsset, setSelectedItemsAsset] = useState([]);
  const [assetsDemo, setAssetsDemo] = useState([]);
  const [distributionBoxes, setDistributionBoxes] = useState([]);
  const [taskList, setTaskList] = useState([]);
  const [sPUserName, setSPUserName] = useState([]);
  const [assetArray, setAssetArray] = useState([]);
  const [testView, setTestView] = useState([]);
  const [viewAssets, setViewAssets] = useState([]);
  const [taskCompletionArrayView, setTaskCompletionArrayView] = useState([]);
  const [distributionBoxFilter, setDistributionBoxfilter] = useState([]);
  const [logbookData, setLogbookData] = useState([]);
  const [logbookDataSiteFilter, setLogbookDataSiteFilter] = useState([]);
  const [dbId, setDBId] = useState([]);
  const [logbookId, setLogbookId] = useState([]);
  const [spCompany, setSpCompany] = useState([]);
  const [repairDataSiteCat, setRepairDataSiteCat] = useState([]);
  const [compID, setCompId] = useState([]);
  const [ao, setAO] = useState([]);
  const [testingsitecat, settestingSitecat] = useState([]);
  const [selectedItemsAssetfordistri, setSelectedItemsAssetfordistri] =
    useState([]);
  const [selectedItemsAssetforLogbook, setSelectedItemsAssetforLogbook] =
    useState([]);
  const [selectedItemsAssetforViceVersa, setSelectedItemsAssetforViceversa] =
    useState([]);
  const [db, setDB] = useState(false);
  const [logbook, setLogbook] = useState(false);
  const [assetTemplateData, setAssetTemplateData] = useState([]);
  const [siteIdvalue, setSiteIdvalue] = useState("");
  const [dbIdvalue, setDBIdvalue] = useState("");
  const { selectedAssetOwnerGlobal, handleAssetOwner } = useContext(aocontext);

  const [assetData, setAssetData] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [existingTask, setExistingTask] = useState([]);
  const [isAssetLocked, setIsAssetLocked] = useState(false);
  const [allowSubmit, setAllowSubmit] = useState(true);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isAllSelectedRepair, setIsAllSelectedRepair] = useState(false);

  // Reusable utility functions for concurrency pooling & caching
  async function asyncPool(poolLimit, array, iteratorFn) {
    const ret = [];
    const executing = [];

    for (const item of array) {
      const p = Promise.resolve().then(() => iteratorFn(item));
      ret.push(p);

      if (poolLimit <= array.length) {
        const e = p.then(() => executing.splice(executing.indexOf(e), 1));
        executing.push(e);

        if (executing.length >= poolLimit) {
          await Promise.race(executing);
        }
      }
    }

    return Promise.all(ret);
  }

  const assetCache = new Map();

  async function getAssetsCached(assetId) {
    if (assetCache.has(assetId)) {
      return assetCache.get(assetId);
    }
    const asset = await getAssets1(assetId);
    assetCache.set(assetId, asset);
    return asset;
  }

  async function fetchSiteDetailsAO() {
    try {
      setIsLoading(true);
      let nextToken = "";
      let sites = [];
      let result = await client.graphql({
        query: queries.siteDetailsByAssetownerID,
        variables: { assetownerID: LoginUserDetails.id, limit: 200000 },
        authMode: "API_KEY",
      });

      let assetDatas = result.data.siteDetailsByAssetownerID.items;
      nextToken = result.data.siteDetailsByAssetownerID.nextToken;
      if (assetDatas.length > 0) sites.push(assetDatas);

      while (nextToken !== null) {
        let results = await client.graphql({
          query: queries.siteDetailsByAssetownerID,
          variables: {
            assetownerID: LoginUserDetails.id,
            limit: 200000,
            nextToken,
          },
          authMode: "API_KEY",
        });
        nextToken = results.data.siteDetailsByAssetownerID.nextToken;
        if (results.data.siteDetailsByAssetownerID.items.length > 0) {
          sites.push(results.data.siteDetailsByAssetownerID.items);
        }
      }

      if (sites.length > 0) {
        const mergeSites = sites.flat(1);
        setSiteDetails(mergeSites.filter((item) => item.status === "Active"));
        SiteData.setSiteData(mergeSites);
        localStorage.setItem("site", base64.encode(JSON.stringify(mergeSites)));
      }
    } catch (error) {
      console.log(error);
      setSiteDetails([]);
      SiteData.setSiteData([]);
    } finally {
      setIsLoading(false);
    }
  }

  async function fetchSiteDetailsSP(assetOwnerId) {
    setIsLoading(true);
    try {
      let nextToken = "";
      let assets = [];
      let result = await client.graphql({
        query: queries.linkUsersAndSitesByUserdetailsID,
        authMode: "API_KEY",
        variables: {
          userdetailsID: assetOwnerId,
          filter: { status: { eq: "Active" } },
          limit: limit,
        },
      });

      let assetDatas = result.data.linkUsersAndSitesByUserdetailsID.items;
      nextToken = result.data.linkUsersAndSitesByUserdetailsID.nextToken;
      if (assetDatas.length > 0) assets.push(assetDatas);

      while (nextToken !== null) {
        let results = await client.graphql({
          query: queries.linkUsersAndSitesByUserdetailsID,
          authMode: "API_KEY",
          variables: {
            userdetailsID: assetOwnerId,
            filter: { status: { eq: "Active" } },
            limit: limit,
            nextToken,
          },
        });
        nextToken = results.data.linkUsersAndSitesByUserdetailsID.nextToken;
        if (results.data.linkUsersAndSitesByUserdetailsID.items.length > 0) {
          assets.push(results.data.linkUsersAndSitesByUserdetailsID.items);
        }
      }

      if (assets.length > 0) {
        const mergeAssets = assets.flat(1);
        const siteDetailsRef = mergeAssets;
        let nextToken1 = "";
        let assets1 = [];

        let siteResult = await client.graphql({
          query: queries.listSiteDetails,
          variables: { limit: limit },
          authMode: "API_KEY",
        });

        let assetDatas1 = siteResult.data.listSiteDetails.items;
        nextToken1 = siteResult.data.listSiteDetails.nextToken;
        if (assetDatas1.length > 0) assets1.push(assetDatas1);

        while (nextToken1 !== null) {
          let results = await client.graphql({
            query: queries.listSiteDetails,
            variables: { limit: limit, nextToken: nextToken1 },
            authMode: "API_KEY",
          });
          nextToken1 = results.data.listSiteDetails.nextToken;
          if (results.data.listSiteDetails.items.length > 0) {
            assets1.push(results.data.listSiteDetails.items);
          }
        }

        if (assets1.length > 0) {
          const mergeAssets1 = assets1.flat(1);
          const siteDetail = mergeAssets1.filter((item) =>
            siteDetailsRef.find((site) => site.sitedetailsID === item?.id),
          );
          setSiteDetails(siteDetail.filter((item) => item.status === "Active"));
          localStorage.setItem(
            "site",
            base64.encode(JSON.stringify(siteDetail)),
          );
          SiteData.setSiteData(siteDetail);
        }
      }
    } catch (error) {
      console.log(error);
      setSiteDetails([]);
    } finally {
      setIsLoading(false);
    }
  }

  async function fetchAssetTemplate() {
    try {
      setIsLoading(true);
      let nextToken = "";
      let assetTemplates = [];
      let dataDetails = await client.graphql({
        query: queries.listAssetTemplates,
        authMode: "API_KEY",
        variables: { limit: 200000 },
      });

      let assetDatas = dataDetails.data.listAssetTemplates.items;
      nextToken = dataDetails.data.listAssetTemplates.nextToken;
      if (assetDatas.length > 0) assetTemplates.push(assetDatas);

      while (nextToken !== null) {
        let dataDetailss = await client.graphql({
          query: queries.listAssetTemplates,
          variables: { limit: 200000, nextToken },
          authMode: "API_KEY",
        });
        nextToken = dataDetailss.data.listAssetTemplates.nextToken;
        if (dataDetailss.data.listAssetTemplates.items.length > 0) {
          assetTemplates.push(dataDetailss.data.listAssetTemplates.items);
        }
      }

      if (assetTemplates.length > 0) {
        const mergeAssetTemplates = assetTemplates.flat(1);
        setAssetTemplateData(mergeAssetTemplates);
        AssetTemplate.setAssetTemplate(mergeAssetTemplates);
        localStorage.setItem(
          "assetTemp",
          base64.encode(JSON.stringify(mergeAssetTemplates)),
        );
      }
    } catch (error) {
      console.log(error);
      setAssetTemplateData([]);
      AssetTemplate.setAssetTemplate([]);
    } finally {
      setIsLoading(false);
    }
  }

  async function fetchCategory() {
    try {
      setIsLoading(true);
      let nextToken = "";
      let categories = [];
      let dataDetails = await client.graphql({
        query: queries.listCategories,
        authMode: "API_KEY",
        variables: { limit: 200000 },
      });

      let assetDatas = dataDetails.data.listCategories.items;
      nextToken = dataDetails.data.listCategories.nextToken;
      if (assetDatas.length > 0) categories.push(assetDatas);

      while (nextToken !== null) {
        let dataDetailss = await client.graphql({
          query: queries.listCategories,
          variables: { limit: 200000, nextToken },
          authMode: "API_KEY",
        });
        nextToken = dataDetailss.data.listCategories.nextToken;
        if (dataDetailss.data.listCategories.items.length > 0) {
          categories.push(dataDetailss.data.listCategories.items);
        }
      }

      if (categories.length > 0) {
        const mergeCategories = categories.flat(1);
        setCategoryDetails(mergeCategories);
        CategoryData.setCategoryData(mergeCategories);
        localStorage.setItem(
          "category",
          base64.encode(JSON.stringify(mergeCategories)),
        );
      }
    } catch (error) {
      console.log(error);
      CategoryData.setCategoryData([]);
      setCategoryDetails([]);
    } finally {
      setIsLoading(false);
    }
  }

  async function fetchSPCompanySPAO(user) {
    try {
      const getSPComp = await client.graphql({
        query: queries.getSPCompanyDetails,
        authMode: "API_KEY",
        variables: { id: user.companyDetailsId },
      });
      if (getSPComp.data.getSPCompanyDetails !== null) {
        let spcomp = [getSPComp.data.getSPCompanyDetails];
        SPCompany.setSPCompany(spcomp);
        setSpCompany(spcomp);
        localStorage.setItem(
          "spCompany",
          base64.encode(JSON.stringify(spcomp)),
        );
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  async function fetchSpcompany(asetOwnerId) {
    try {
      const getLinkAOAPCompanyDetails = await client.graphql({
        query: queries.listLinkAOAPCompanies,
        authMode: "API_KEY",
        variables: { limit: 10000, filter: { spaoId: { eq: asetOwnerId } } },
      });
      const items = getLinkAOAPCompanyDetails.data.listLinkAOAPCompanies.items;
      if (items.length > 0) {
        SPCompany.setSPCompany(items);
        setSpCompany(items);
        localStorage.setItem("spCompany", base64.encode(JSON.stringify(items)));
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  async function fetchSPCompanySU(userId) {
    try {
      const getLinkAOAPCompanyDetails = await client.graphql({
        query: queries.listLinkAOAPCompanies,
        authMode: "API_KEY",
        variables: { limit: 10000, filter: { spaoId: { eq: userId } } },
      });
      const items = getLinkAOAPCompanyDetails.data.listLinkAOAPCompanies.items;
      if (items.length > 0) {
        SPCompany.setSPCompany(items);
        setSpCompany(items);
        localStorage.setItem("spCompany", base64.encode(JSON.stringify(items)));
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  async function fetchSPUser() {
    try {
      let nextToken = "";
      let assets = [];
      let result = await client.graphql({
        query: queries.listSPUserDetails,
        variables: { limit: limit },
        authMode: "API_KEY",
      });
      let assetDatas = result.data.listSPUserDetails.items;
      nextToken = result.data.listSPUserDetails.nextToken;
      if (assetDatas.length > 0) assets.push(assetDatas);

      while (nextToken !== null) {
        let results = await client.graphql({
          query: queries.listSPUserDetails,
          variables: { limit: limit, nextToken },
          authMode: "API_KEY",
        });
        nextToken = results.data.listSPUserDetails.nextToken;
        if (results.data.listSPUserDetails.items.length > 0) {
          assets.push(results.data.listSPUserDetails.items);
        }
      }
      if (assets.length > 0) {
        setSPUserName(assets.flat(1));
      }
    } catch (error) {
      console.log(error);
      setSPUserName([]);
    }
  }

  async function fetchDb() {
    if (siteDetails.length > 0) {
      let assets = [];
      for (const item of siteDetails) {
        let nextToken = "";
        let result = await client.graphql({
          query: queries.distributionBoxesBySitedetailsID,
          variables: { sitedetailsID: item.id, limit: limit },
          authMode: "API_KEY",
        });
        let assetDatas = result.data.distributionBoxesBySitedetailsID.items;
        nextToken = result.data.distributionBoxesBySitedetailsID.nextToken;
        if (assetDatas.length > 0) assets.push(assetDatas);

        while (nextToken !== null) {
          let results = await client.graphql({
            query: queries.distributionBoxesBySitedetailsID,
            variables: { limit: limit, sitedetailsID: item.id, nextToken },
            authMode: "API_KEY",
          });
          nextToken = results.data.distributionBoxesBySitedetailsID.nextToken;
          if (results.data.distributionBoxesBySitedetailsID.items.length > 0) {
            assets.push(results.data.distributionBoxesBySitedetailsID.items);
          }
        }
      }
      if (assets.length > 0) {
        const mergeAssets = assets.flat(1);
        setDistributionBoxes(mergeAssets);
        SiteDBData.setSiteDBData(mergeAssets);
        localStorage.setItem(
          "siteDB",
          base64.encode(JSON.stringify(mergeAssets)),
        );
      } else {
        setDistributionBoxes([]);
      }
    } else {
      let nextToken = "";
      let assets = [];
      let result = await client.graphql({
        query: queries.listDistributionBoxes,
        variables: { limit: limit },
        authMode: "API_KEY",
      });
      let assetDatas = result.data.listDistributionBoxes.items;
      nextToken = result.data.listDistributionBoxes.nextToken;
      if (assetDatas.length > 0) assets.push(assetDatas);

      while (nextToken !== null) {
        let results = await client.graphql({
          query: queries.listDistributionBoxes,
          variables: { limit: limit, nextToken },
          authMode: "API_KEY",
        });
        nextToken = results.data.listDistributionBoxes.nextToken;
        if (results.data.listDistributionBoxes.items.length > 0) {
          assets.push(results.data.listDistributionBoxes.items);
        }
      }
      if (assets.length > 0) {
        const mergeAssets = assets.flat(1);
        setDistributionBoxes(mergeAssets);
        SiteDBData.setSiteDBData(mergeAssets);
        localStorage.setItem(
          "siteDB",
          base64.encode(JSON.stringify(mergeAssets)),
        );
      } else {
        setDistributionBoxes([]);
      }
    }
  }

  function getTaskAssigneeName(sPId) {
    const TaskAssigneeName = sPUserName.find((item) => item.id === sPId);
    return TaskAssigneeName ? TaskAssigneeName.email : "";
  }

  function getSiteUnitNumber(siteid) {
    const unitNumber = siteDetails.find((item) => item.id === siteid);
    return unitNumber ? `${unitNumber.siteName} ${unitNumber.unitNumber}` : "";
  }

  function getCategory(catid) {
    const category = categoryDetails.find((item) => item.id === catid);
    return category ? category.categoryName : "";
  }

  useEffect(() => {
    fetchSPUser();
    if (
      localStorage.getItem("siteDB") === null &&
      distributionBoxes.length === 0
    ) {
      fetchDb();
    } else {
      setDistributionBoxes(SiteDBData.getSiteDBData());
    }
    if (
      localStorage.getItem("assetTemp") === null &&
      assetTemplateData.length === 0
    ) {
      fetchAssetTemplate();
    } else {
      setAssetTemplateData(AssetTemplate.getAssetTemplate());
    }
    if (
      localStorage.getItem("category") === null &&
      categoryDetails.length === 0
    ) {
      fetchCategory();
    } else {
      setCategoryDetails(CategoryData.getCategoryData());
    }

    if (id) {
      async function listTasks() {
        try {
          let nextToken = "";
          let assets = [];
          let result = await client.graphql({
            query: queries.listTasks,
            variables: {
              limit: limit,
              filter: { id: { eq: id }, taskStatus: { ne: "Completed" } },
            },
            authMode: "API_KEY",
          });
          let assetDatas = result.data.listTasks.items;
          nextToken = result.data.listTasks.nextToken;
          if (assetDatas.length > 0) assets.push(assetDatas);

          while (nextToken !== null) {
            let results = await client.graphql({
              query: queries.listTasks,
              variables: {
                limit: limit,
                filter: { id: { eq: id }, taskStatus: { ne: "Completed" } },
                nextToken,
              },
              authMode: "API_KEY",
            });
            nextToken = results.data.listTasks.nextToken;
            if (results.data.listTasks.items.length > 0) {
              assets.push(results.data.listTasks.items);
            }
          }

          if (assets.length > 0) {
            const mergeAssets = assets.flat(1);
            const tasks = mergeAssets.filter(
              (item) => !item._deleted && item.id === id,
            );

            if (tasks[0].taskType === "Test") {
              const taskscompletionlink = JSON.parse(
                tasks[0].taskCompletionLink,
              );
              const assetList = taskscompletionlink[0].assets;
              getMultipleAssetsView(assetList).then((assetDataRes) => {
                setViewAssets(assetDataRes.length > 0 ? assetDataRes : []);
              });

              setTaskCompletionArrayView(
                JSON.parse(tasks[0].taskCompletionLink),
              );
              if (taskscompletionlink && taskscompletionlink.length > 0) {
                if (taskscompletionlink[0].assets.length > 0) {
                  setAssetArray(taskscompletionlink[0].assets[0]);
                }
              }
            }

            if (
              tasks[0].taskType === "Repair" ||
              tasks[0].taskType === "Replace"
            ) {
              setTaskCompletionArrayView(
                JSON.parse(tasks[0].taskCompletionLink),
              );
              const taskCompletionLinkArray = JSON.parse(
                tasks[0].taskCompletionLink,
              );
              const testList = taskCompletionLinkArray[0].test;
              getMultipleTestsView(testList).then((testDataRes) => {
                setTestView(testDataRes.length > 0 ? testDataRes : []);
              });
            }

            setTaskList({ ...tasks[0] });
            reset({ ...tasks[0] });
          }
        } catch (error) {
          console.log(error);
        }
      }
      listTasks();
    }
  }, [id, reset]);

  async function getAssetsView(aid) {
    try {
      const data = await client.graphql({
        query: queries.getAssets,
        authMode: "API_KEY",
        variables: { id: aid },
      });
      return data.data.getAssets !== null ? data.data.getAssets : null;
    } catch (error) {
      console.error("Error fetching asset with id", aid, ":", error);
      return null;
    }
  }

  async function getTestsView(aid) {
    try {
      const data = await client.graphql({
        query: queries.getTesting,
        authMode: "API_KEY",
        variables: { id: aid },
      });
      return data.data.getTesting !== null ? data.data.getTesting : null;
    } catch (error) {
      console.error("Error fetching getTesting with id", aid, ":", error);
      return null;
    }
  }

  const getAssetsViewrepair = async (aid) => {
    try {
      const data = await client.graphql({
        query: queries.getAssets,
        authMode: "API_KEY",
        variables: { id: aid },
      });
      if (data.data.getAssets !== null) {
        const fittingNumberr = data.data.getAssets.fittingNumber;
        setAssetData((prevState) => ({ ...prevState, [aid]: fittingNumberr }));
      } else {
        setAssetData((prevState) => ({ ...prevState, [aid]: null }));
      }
    } catch (error) {
      console.error("Error fetching asset with id", aid, ":", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (testView.length > 0) {
      testView.forEach((item) => {
        if (item.assetsID) {
          getAssetsViewrepair(item.assetsID);
        }
      });
    }
  }, [testView]);

  async function getMultipleAssetsView(assetIds) {
    try {
      const assetPromises = assetIds.map((id) => getAssetsView(id));
      const assetDataRes = await Promise.all(assetPromises);
      return assetDataRes.filter((asset) => asset !== null);
    } catch (error) {
      console.error("Error fetching multiple assets:", error);
      return [];
    }
  }

  async function getMultipleTestsView(assetIds) {
    try {
      const assetPromises = assetIds.map((id) => getTestsView(id));
      const assetDataRes = await Promise.all(assetPromises);
      return assetDataRes.filter((asset) => asset !== null);
    } catch (error) {
      console.error("Error fetching multiple assets:", error);
      return [];
    }
  }

  const updatePage1 = (p) => {
    setCurrentPage(p);
    const to = countPerPage * p;
    const from = to - countPerPage;
    setRepairData(cloneDeep(repairDemo.slice(from, to)));
    setTesting(cloneDeep(testingDemo.slice(from, to)));
  };

  async function fetchUserdetails() {
    try {
      let nextToken = "";
      let assets = [];
      let result = await client.graphql({
        query: queries.listSPUserDetails,
        variables: { limit: limit },
        authMode: "API_KEY",
      });
      let assetDatas = result.data.listSPUserDetails.items;
      nextToken = result.data.listSPUserDetails.nextToken;
      if (assetDatas.length > 0) assets.push(assetDatas);

      while (nextToken !== null) {
        let results = await client.graphql({
          query: queries.listSPUserDetails,
          variables: { limit: limit, nextToken },
          authMode: "API_KEY",
        });
        nextToken = results.data.listSPUserDetails.nextToken;
        if (results.data.listSPUserDetails.items.length > 0) {
          assets.push(results.data.listSPUserDetails.items);
        }
      }
      setTechnician(assets.length > 0 ? assets.flat(1) : []);
    } catch (error) {
      console.log(error);
      setTechnician([]);
    }
  }

  function getTechnicianName(technicianId) {
    const technicianName = technician.find((item) => item.id === technicianId);
    return technicianName ? technicianName.email : "";
  }

  function getDBName(dbId) {
    const assetNew = distributionBoxes.find((item) => item.id === dbId);
    return assetNew ? assetNew.distributionBoxName : "";
  }

  function logbookname(logbook) {
    const assetNew = logbookData.find((item) => item.id === logbook);
    return assetNew ? assetNew.logbookName : "";
  }

  const cancelForm = () => {
    if (LoginUserGroup === "spao") {
      if (state.state && state.state.menu === "sp") {
        navigate(`${process.env.PUBLIC_URL}/taskssp`);
      } else {
        navigate(`${process.env.PUBLIC_URL}/tasksaosp`);
      }
    } else {
      navigate(`${process.env.PUBLIC_URL}/tasksao`);
    }
  };

  async function fetchLogbooksSites() {
    try {
      let nextToken = "";
      let logbook = [];
      let result = await client.graphql({
        query: queries.listLogBooks,
        variables: { limit: limit },
        authMode: "API_KEY",
      });
      let assetDatas = result.data.listLogBooks.items;
      nextToken = result.data.listLogBooks.nextToken;
      if (assetDatas.length > 0) logbook.push(assetDatas);

      while (nextToken !== null) {
        let results = await client.graphql({
          query: queries.listLogBooks,
          variables: { limit: limit, nextToken },
          authMode: "API_KEY",
        });
        nextToken = results.data.listLogBooks.nextToken;
        if (results.data.listLogBooks.items.length > 0) {
          logbook.push(results.data.listLogBooks.items);
        }
      }
      setLogbookData(logbook.length > 0 ? logbook.flat(1) : []);
    } catch (error) {
      console.log(error);
      setLogbookData([]);
    }
  }

  async function getAssets1(aid) {
    try {
      const data = await client.graphql({
        query: queries.getAssets,
        authMode: "API_KEY",
        variables: { id: aid },
      });
      const asset = data?.data?.getAssets;
      if (!asset) return null;
      return {
        fittingNumber: asset.fittingNumber,
        distributionboxID: asset.distributionboxID,
        assettemplateID: asset.assettemplateID,
      };
    } catch (error) {
      console.error("Error fetching asset:", error);
      return null;
    }
  }

  useEffect(() => {
    async function fetchSitesDetails() {
      try {
        setIsLoading(true);
        setIsLoadingRepair(true);
        let nextToken = "";
        let assets = [];
        let result = await client.graphql({
          query: queries.assetsBySitedetailsID,
          variables: {
            sitedetailsID: siteId,
            filter: { status: { eq: "Active" } },
            limit: limit,
          },
        });

        let assetDatas = result.data.assetsBySitedetailsID.items;
        nextToken = result.data.assetsBySitedetailsID.nextToken;
        if (assetDatas.length > 0) assets.push(assetDatas);

        while (nextToken !== null) {
          let results = await client.graphql({
            query: queries.assetsBySitedetailsID,
            variables: {
              sitedetailsID: siteId,
              filter: { status: { eq: "Active" } },
              limit: limit,
              nextToken,
            },
          });
          nextToken = results.data.assetsBySitedetailsID.nextToken;
          if (results.data.assetsBySitedetailsID.items.length > 0) {
            assets.push(results.data.assetsBySitedetailsID.items);
          }
        }

        if (assets.length > 0) {
          const mergeAssets = assets.flat(1);
          if (mergeAssets.length > 0) {
            const sort = mergeAssets.sort(
              (a, b) => a.fittingNumber - b.fittingNumber,
            );
            setAssetsDemo(sort);
            setAssetSiteCatFilter(cloneDeep(sort.slice(0, countPerPage)));
            setAssetSiteCat(sort);

            let nextToken2 = "";
            let assets2 = [];
            let testResult = await client.graphql({
              query: queries.testingsBySitedetailsID,
              variables: {
                sitedetailsID: siteId,
                filter: { testResult: { eq: "Fail" } },
                limit: limit,
              },
              authMode: "API_KEY",
            });

            let testAssetDatas = testResult.data.testingsBySitedetailsID.items;
            nextToken2 = testResult.data.testingsBySitedetailsID.nextToken;
            if (testAssetDatas.length > 0) assets2.push(testAssetDatas);

            while (nextToken2 !== null) {
              let results = await client.graphql({
                query: queries.testingsBySitedetailsID,
                variables: {
                  sitedetailsID: siteId,
                  filter: { testResult: { eq: "Fail" } },
                  limit: limit,
                  nextToken: nextToken2,
                },
                authMode: "API_KEY",
              });
              nextToken2 = results.data.testingsBySitedetailsID.nextToken;
              if (results.data.testingsBySitedetailsID.items.length > 0) {
                assets2.push(results.data.testingsBySitedetailsID.items);
              }
            }

            if (assets2.length > 0) {
              const mergeAssets2 = assets2.flat(1);
              const testArray = [];

              await asyncPool(50, mergeAssets2, async (test) => {
                const assetInfo = await getAssetsCached(test.assetsID);
                testArray.push({
                  id: test.id,
                  createdAt: test.createdAt,
                  testOn: test.testOn,
                  testResult: test.testResult,
                  nextTestSchedule: test.nextTestSchedule,
                  additionalInformation: test.additionalInformation,
                  assetsID: assetInfo?.fittingNumber || null,
                  assetsId: test.assetsID,
                  assettemplateID:
                    test.assettemplateSiteID?.split("_")[0] || null,
                  distributionboxID: assetInfo?.distributionboxID || null,
                  technician: test.technician,
                  logbookID: test.logbookID,
                });
              });

              setRepairDemo(testArray);
              settestingSitecat(testArray);
              setRepairData(cloneDeep(testArray.slice(0, countPerPage)));
            } else {
              setRepairDemo([]);
              settestingSitecat([]);
              setRepairData(cloneDeep([].slice(0, countPerPage)));
            }
          } else {
            setAssetsDemo([]);
            setAssetSiteCatFilter(cloneDeep([].slice(0, countPerPage)));
            setAssetSiteCat([]);
          }
        } else {
          setAssetsDemo([]);
          setAssetSiteCatFilter(cloneDeep([].slice(0, countPerPage)));
          setAssetSiteCat([]);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
        setIsLoadingRepair(false);
      }
    }

    if (siteId !== "") {
      setLogbookDataSiteFilter(
        logbookData.filter(
          (item) => item.siteId === siteId && item.logbookName !== null,
        ),
      );
      if (distributionBoxes.length > 0) {
        setDistributionBoxfilter(
          distributionBoxes.filter((item) => item.sitedetailsID === siteId),
        );
      }
    } else {
      setDistributionBoxfilter(distributionBoxes);
      setLogbookDataSiteFilter(logbookData);
      setAssetsDemo([]);
      setAssetSiteCatFilter(cloneDeep([].slice(0, countPerPage)));
      setAssetSiteCat([]);
    }
  }, [siteId]);

  useEffect(() => {
    async function fetchSitesDetailsDistri() {
      try {
        setIsLoading(true);
        setIsLoadingRepair(true);
        if (dbId !== "") {
          const assetNewdistri = logbook
            ? selectedItemsAssetforViceVersa
            : selectedItemsAssetfordistri;
          if (assetNewdistri.length > 0) {
            const AssetDataFilter = assetNewdistri.filter(
              (item) => item.distributionboxID === dbId,
            );
            const sort = AssetDataFilter.sort(
              (a, b) => a.fittingNumber - b.fittingNumber,
            );
            setAssetsDemo(sort);
            setAssetSiteCatFilter(cloneDeep(sort.slice(0, countPerPage)));
            setSelectedItemsAssetforLogbook(sort);
          }
          setDB(true);
          const datafilter = repairDataSiteCat.filter(
            (item) => item.logbookID === logbookId,
          );
          const distri = (logbookId ? datafilter : repairDataSiteCat).filter(
            (item) => item.distributionboxID === dbId,
          );
          setRepairDemo(distri);
          setRepairData(cloneDeep(distri.slice(0, countPerPage)));
        } else {
          setDB(false);
          const assetNewdistri = logbook
            ? selectedItemsAssetforViceVersa
            : selectedItemsAssetfordistri;
          const sort = assetNewdistri.sort(
            (a, b) => a.fittingNumber - b.fittingNumber,
          );
          setAssetsDemo(sort);
          setAssetSiteCatFilter(cloneDeep(sort.slice(0, countPerPage)));
          setSelectedItemsAssetforLogbook(sort);
          if (logbookId) {
            const datafilter = repairDataSiteCat.filter(
              (item) => item.logbookID === logbookId,
            );
            setRepairDemo(datafilter);
            setRepairData(cloneDeep(datafilter.slice(0, countPerPage)));
          } else {
            setRepairDemo(repairDataSiteCat);
            setRepairData(cloneDeep(repairDataSiteCat.slice(0, countPerPage)));
          }
        }
      } finally {
        setIsLoading(false);
        setIsLoadingRepair(false);
      }
    }
    fetchSitesDetailsDistri();
  }, [dbId]);

  useEffect(() => {
    async function fetchSitesDetailsLogbook() {
      try {
        setIsLoading(true);
        setIsLoadingRepair(true);
        if (logbookId !== "") {
          const assetNewdistri =
            Array.isArray(dbId) && dbId.length > 0
              ? selectedItemsAssetforLogbook
              : selectedItemsAssetfordistri;

          setLogbook(true);
          if (assetNewdistri.length > 0) {
            const AssetDataFilter = assetNewdistri.filter(
              (item) => item.logbookId === logbookId,
            );
            const sort = AssetDataFilter.sort(
              (a, b) => a.fittingNumber - b.fittingNumber,
            );
            setAssetsDemo(sort);
            setAssetSiteCatFilter(cloneDeep(sort.slice(0, countPerPage)));
            setSelectedItemsAssetforViceversa(sort);
          }
          const testReport = repairDataSiteCat.filter(
            (item) => item.logbookID === logbookId,
          );
          setRepairDemo(testReport);
          setRepairData(cloneDeep(testReport.slice(0, countPerPage)));
        } else {
          setLogbook(false);
          const assetNewdistri =
            Array.isArray(dbId) && dbId.length > 0
              ? selectedItemsAssetforLogbook
              : selectedItemsAssetfordistri;

          const sort = assetNewdistri.sort(
            (a, b) => a.fittingNumber - b.fittingNumber,
          );
          setAssetsDemo(sort);
          setAssetSiteCatFilter(cloneDeep(sort.slice(0, countPerPage)));
          setSelectedItemsAssetforViceversa(sort);
          setRepairDemo(repairDataSiteCat);
          setRepairData(cloneDeep(repairDataSiteCat.slice(0, countPerPage)));
        }
      } finally {
        setIsLoading(false);
        setIsLoadingRepair(false);
      }
    }
    fetchSitesDetailsLogbook();
  }, [logbookId]);

  async function getAssetsByTemplates(assetTemplates, siteID) {
    setIsLoading(true);
    try {
      const allAssets = await Promise.all(
        assetTemplates.map(async (assetTemplate) => {
          const tempSiteId = assetTemplate.id + "_" + siteID;
          let nextToken = null;
          let items = [];

          let response = await client.graphql({
            query: queries.assetsByAssettemplateSiteIDAndAssetNum,
            variables: {
              assettemplateSiteID: tempSiteId,
              limit: limit,
              filter: { status: { eq: "Active" } },
            },
            authMode: "API_KEY",
          });

          items.push(
            ...response.data.assetsByAssettemplateSiteIDAndAssetNum.items,
          );
          nextToken =
            response.data.assetsByAssettemplateSiteIDAndAssetNum.nextToken;

          while (nextToken) {
            const nextResp = await client.graphql({
              query: queries.assetsByAssettemplateSiteIDAndAssetNum,
              variables: {
                assettemplateSiteID: tempSiteId,
                limit: limit,
                nextToken: nextToken,
                filter: { status: { eq: "Active" } },
              },
              authMode: "API_KEY",
            });
            items.push(
              ...nextResp.data.assetsByAssettemplateSiteIDAndAssetNum.items,
            );
            nextToken =
              nextResp.data.assetsByAssettemplateSiteIDAndAssetNum.nextToken;
          }
          return items;
        }),
      );

      const merged = allAssets.flat();
      const sorted = merged.sort((a, b) => a.fittingNumber - b.fittingNumber);

      setAssetsDemo(sorted);
      setAssetSiteCatFilter(cloneDeep(sorted.slice(0, countPerPage)));
      setSelectedItemsAssetfordistri(sorted);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    async function fetchSitesDetailsData() {
      try {
        setIsLoading(true);
        setIsLoadingRepair(true);

        if (selectedTaskType === "Test" && catId !== "") {
          const templates = assetTemplateData.filter(
            (item) => item.categoriesID === catId && item.status === "Active",
          );
          if (templates.length > 0) {
            await getAssetsByTemplates(templates, siteId);
          }
        } else if (selectedTaskType !== "Test" && catId !== "") {
          const templates = assetTemplateData.filter(
            (item) => item.categoriesID === catId && item.status === "Active",
          );
          if (templates.length > 0) {
            await testingdatasitecat(templates);
            await getAssetsByTemplates(templates, siteId);
          }
        } else {
          setAssetsDemo(assetSiteCat);
          setAssetSiteCatFilter(cloneDeep(assetSiteCat.slice(0, countPerPage)));
          setSelectedItemsAssetfordistri(assetSiteCat);
          setRepairDemo(testingsitecat);
          setRepairData(cloneDeep(testingsitecat.slice(0, countPerPage)));
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
        setIsLoadingRepair(false);
      }
    }
    fetchSitesDetailsData();
  }, [catId]);

  async function testingdatasitecat(templates) {
    try {
      let allAssets = [];
      await Promise.all(
        templates.map(async (template) => {
          let nextToken = null;
          let templateAssets = [];
          do {
            const result = await client.graphql({
              query: queries.testingsByAssettemplateSiteID,
              variables: {
                assettemplateSiteID: `${template.id}_${siteId}`,
                filter: { testResult: { eq: "Fail" } },
                limit: limit,
                nextToken: nextToken,
              },
              authMode: "API_KEY",
            });
            const response = result.data.testingsByAssettemplateSiteID;
            nextToken = response.nextToken;
            if (response.items?.length > 0) {
              templateAssets.push(...response.items);
            }
          } while (nextToken);
          allAssets.push(...templateAssets);
        }),
      );

      if (!allAssets.length) {
        setRepairDemo([]);
        setRepairDataSiteCat([]);
        settestingSitecat([]);
        setRepairData(cloneDeep([].slice(0, countPerPage)));
        setIsLoadingRepair(false);
        return;
      }

      const testArray = [];
      await asyncPool(50, allAssets, async (test) => {
        const assetInfo = await getAssetsCached(test.assetsID);
        testArray.push({
          id: test.id,
          createdAt: test.createdAt,
          testOn: test.testOn,
          testResult: test.testResult,
          nextTestSchedule: test.nextTestSchedule,
          additionalInformation: test.additionalInformation,
          assetsID: assetInfo?.fittingNumber || null,
          assetsId: test.assetsID,
          assettemplateID: test.assettemplateSiteID?.split("_")[0] || null,
          distributionboxID: assetInfo?.distributionboxID || null,
          technician: test.technician,
          logbookID: test.logbookID,
        });
      });

      setRepairDataSiteCat(testArray);
      setRepairDemo(testArray);
      settestingSitecat(testArray);
      setRepairData(cloneDeep(testArray.slice(0, countPerPage)));
      setIsLoadingRepair(false);
    } catch (error) {
      console.error(error);
      setIsLoadingRepair(false);
    }
  }

  const handleCheckboxAssetChange = (event, item) => {
    const isChecked = event.target.checked;
    if (item === "selectAll") {
      setIsAllSelected(isChecked);
      setSelectedItemsAsset(isChecked ? assetsDemo.slice() : []);
    } else {
      setSelectedItemsAsset((prevSelectedItems) => {
        const updatedItems = isChecked
          ? [...prevSelectedItems, item]
          : prevSelectedItems.filter((selectedItem) => selectedItem !== item);
        setIsAllSelected(updatedItems.length === assetsDemo.length);
        return updatedItems;
      });
    }
  };

  const handleCheckboxChange = (event, item) => {
    const isChecked = event.target.checked;
    if (item === "selectAll") {
      setIsAllSelectedRepair(isChecked);
      setSelectedItems(isChecked ? repairDemo.slice() : []);
    } else {
      setSelectedItems((prevSelectedItems) => {
        if (isChecked && !prevSelectedItems.includes(item)) {
          return [...prevSelectedItems, item];
        } else if (!isChecked && prevSelectedItems.includes(item)) {
          return prevSelectedItems.filter(
            (selectedItem) => selectedItem !== item,
          );
        }
        return prevSelectedItems;
      });
      setIsAllSelectedRepair(selectedItems.length === repairDemo.length);
    }
  };

  const updatePage2 = (p) => {
    setCurrentPage1(p);
    const to = countPerPage * p;
    const from = to - countPerPage;
    setAssetSiteCatFilter(cloneDeep(assetsDemo.slice(from, to)));
  };

  async function fetchSpuserforSpComp(compId) {
    if (compId.length > 0) {
      try {
        const response = await client.graphql({
          query: queries.listUserDetails,
          authMode: "API_KEY",
          variables: {
            filter: { companyDetailsId: { eq: compId } },
            limit: limit,
          },
        });
        const spuser = response.data.listUserDetails.items;
        if (spuser.length > 0) {
          const response3 = await client.graphql({
            query: queries.listSPUserDetails,
            authMode: "API_KEY",
            variables: {
              filter: {
                status: { eq: "Active" },
                userGroup: { eq: "electrician" },
              },
              limit: limit,
            },
          });
          const spDetails2 = response3.data.listSPUserDetails.items.filter(
            (item) => spuser.find((user) => user.id === item?.id),
          );
          setSPUser(spDetails2);
        } else {
          setSPUser([]);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setSPUser([]);
    }
  }

  async function fetchAO() {
    try {
      let nextToken = "";
      let assets = [];
      let result = await client.graphql({
        query: queries.listAssetOwners,
        variables: { limit: limit },
        authMode: "API_KEY",
      });
      let assetDatas = result.data.listAssetOwners.items;
      nextToken = result.data.listAssetOwners.nextToken;
      if (assetDatas.length > 0) assets.push(assetDatas);

      while (nextToken !== null) {
        let results = await client.graphql({
          query: queries.listAssetOwners,
          variables: { limit: limit, nextToken },
          authMode: "API_KEY",
        });
        nextToken = results.data.listAssetOwners.nextToken;
        if (results.data.listAssetOwners.items.length > 0) {
          assets.push(results.data.listAssetOwners.items);
        }
      }
      setAO(assets.length > 0 ? assets.flat(1) : []);
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchAOSP() {
    try {
      let nextToken = "";
      let assets = [];
      let result = await client.graphql({
        query: queries.listSPUserDetails,
        variables: { limit: limit },
        authMode: "API_KEY",
      });
      let assetDatas = result.data.listSPUserDetails.items;
      nextToken = result.data.listSPUserDetails.nextToken;
      if (assetDatas.length > 0) assets.push(assetDatas);

      while (nextToken !== null) {
        let results = await client.graphql({
          query: queries.listSPUserDetails,
          variables: { limit: limit, nextToken },
          authMode: "API_KEY",
        });
        nextToken = results.data.listSPUserDetails.nextToken;
        if (results.data.listSPUserDetails.items.length > 0) {
          assets.push(results.data.listSPUserDetails.items);
        }
      }
      setAO(assets.length > 0 ? assets.flat(1) : []);
    } catch (error) {
      console.log(error);
    }
  }

  function getCompany(cid) {
    const technicianName =
      LoginUserGroup === "site_owner"
        ? spCompany.find((item) => item.spcomapnyId === cid)
        : spCompany.find((item) => item.id === cid);
    return technicianName ? technicianName.companyName : "";
  }

  const sendEmail = async (recipientEmail, taskData) => {
    const {
      assignedBy,
      TaskType,
      TaskStatus,
      DueDate,
      site,
      category,
      logbook,
      distributionBoard,
      company,
    } = taskData;

    let message = `
    <html>
    <body>
      <p>Hello,</p>
      <p>You have been assigned a new task:</p>
      <table style="border-collapse: collapse; width: 80%; border: 1px solid black;">
        <tr style="border-bottom: 1px solid black;">
          <td style="border-right: 1px solid black;"><strong>Task Assigned By:</strong></td>
          <td>${assignedBy}</td>
        </tr>       
        <tr style="border-bottom: 1px solid black;">
          <td style="border-right: 1px solid black;"><strong>Task Type:</strong></td>
          <td>${TaskType}</td>
        </tr>
        <tr style="border-bottom: 1px solid black;">
          <td style="border-right: 1px solid black;"><strong>Task Status:</strong></td>
          <td>${TaskStatus}</td>
        </tr>
        <tr style="border-bottom: 1px solid black;">
          <td style="border-right: 1px solid black;"><strong>Company:</strong></td>
          <td>${company}</td>
        </tr>
        <tr style="border-bottom: 1px solid black;">
          <td style="border-right: 1px solid black;"><strong>Site:</strong></td>
          <td>${site}</td>
        </tr>
        <tr style="border-bottom: 1px solid black;">
          <td style="border-right: 1px solid black;"><strong>Distribution Board:</strong></td>
          <td>${distributionBoard}</td>
        </tr>
        <tr style="border-bottom: 1px solid black;">
          <td style="border-right: 1px solid black;"><strong>Logbook:</strong></td>
          <td>${logbook}</td>
        </tr>
        <tr style="border-bottom: 1px solid black;">
          <td style="border-right: 1px solid black;"><strong>Category:</strong></td>
          <td>${category}</td>
        </tr>
        <tr style="border-bottom: 1px solid black;">
          <td style="border-right: 1px solid black;"><strong>Due Date:</strong></td>
          <td>${DueDate}</td>
        </tr>
      </table>`;

    if (selectedItemsAsset && selectedItemsAsset.length > 0) {
      message += `
      <p><strong>Assets:</strong></p>
      <table style="border-collapse: collapse; width: 100%; border: 1px solid black;">
        <tr style="border-bottom: 1px solid black;">
          <td style="border-right: 1px solid black;"><strong>Fitting Number</strong></td>
          <td style="border-right: 1px solid black;"><strong>Asset Model</strong></td>
          <td style="border-right: 1px solid black;"><strong>Asset Location</strong></td>
          <td style="border-right: 1px solid black;"><strong>Asset Description</strong></td>
          <td style="border-right: 1px solid black;"><strong>Installed On</strong></td>
          <td style="border-right: 1px solid black;"><strong>Warranty Start</strong></td>
          <td><strong>Warranty End</strong></td>
        </tr>`;
      selectedItemsAsset.forEach((asset) => {
        message += `
          <tr style="border-bottom: 1px solid black;">
            <td style="border-right: 1px solid black;">${asset.fittingNumber}</td>
            <td style="border-right: 1px solid black;">${asset.assetModel}</td>
            <td style="border-right: 1px solid black;">${asset.assetLocation}</td>
            <td style="border-right: 1px solid black;">${asset.assetDescription}</td>
            <td style="border-right: 1px solid black;">${moment(asset.installedOn).format("DD/MM/YYYY")}</td>
            <td style="border-right: 1px solid black;">${moment(asset.assetWarrantyStart).format("DD/MM/YYYY")}</td>
            <td>${moment(asset.assetWarrantyEnd).format("DD/MM/YYYY")}</td>
          </tr>`;
      });
      message += `</table>`;
    }

    if (selectedItems && selectedItems.length > 0) {
      message += `
      <p><strong>Test:</strong></p>
      <table style="border-collapse: collapse; width: 100%; border: 1px solid black;">
        <tr style="border-bottom: 1px solid black;">
          <td style="border-right: 1px solid black;"><strong>Fitting NO.</strong></td>
          <td style="border-right: 1px solid black;"><strong>Test On</strong></td>
          <td style="border-right: 1px solid black;"><strong>Test Result</strong></td>
          <td><strong>Next Test Schedule Date</strong></td>
        </tr>`;
      selectedItems.forEach((assetTest) => {
        message += `
        <tr style="border-bottom: 1px solid black;">
          <td style="border-right: 1px solid black;">${assetTest.assetsID}</td>
          <td style="border-right: 1px solid black;">${moment(assetTest.testOn).format("DD/MM/YYYY")}</td>
          <td style="border-right: 1px solid black;">${assetTest.testResult}</td>
          <td>${moment(assetTest.nextTestSchedule).format("DD/MM/YYYY")}</td>
        </tr>`;
      });
      message += `</table>`;
    }

    message += `
      <p>Please complete the task by the due date.</p>
      <p>Best regards,</p>
      <p>KYA</p>
    </body>
    </html>`;

    try {
      await axios.post(EMAIL_API, {
        body: JSON.stringify({
          email: recipientEmail,
          subject: "Task Assigned",
          messageBody: message,
        }),
      });
    } catch (error) {
      console.log("error ", error);
    }
  };

  useEffect(() => {
    fetchLogbooksSites();
    if (localStorage.getItem("site") === null && siteDetails.length === 0) {
      if (LoginUserGroup === "site_owner") fetchSiteDetailsAO();
      else if (LoginUserGroup === "site_user") fetchSiteDetailsSU();
      else fetchSiteDetailsSP(LoginUserDetails.id);
    } else {
      let activeSites = JSON.parse(base64.decode(localStorage.getItem("site")));
      setSiteDetails(activeSites.filter((item) => item.status === "Active"));
      setSiteFilter(activeSites.filter((item) => item.status === "Active"));
    }
    if (localStorage.getItem("spCompany") === null && spCompany.length === 0) {
      if (LoginUserGroup === "site_owner") fetchSpcompany(LoginUserDetails.id);
      else if (
        LoginUserGroup === "site_user" ||
        LoginUserGroup === "electrician"
      )
        fetchSPCompanySU(LoginUserDetails.id);
      else fetchSPCompanySPAO(LoginUserDetails);
    } else {
      setSpCompany(
        JSON.parse(base64.decode(localStorage.getItem("spCompany"))),
      );
    }
    if (LoginUserGroup === "site_owner") fetchAO();
    else if (LoginUserGroup === "electrician" || LoginUserGroup === "spao")
      fetchAOSP();
    fetchUserdetails();
  }, [selectedAssetOwnerGlobal]);

  async function fetchSiteDetailsSU() {
    try {
      const response = await client.graphql({
        query: mergedQueries.getSiteUsersFromLink,
        authMode: "API_KEY",
        variables: {
          assetownerID: LoginUserDetails.assetOwnerId,
          userdetailsID: LoginUserDetails.id,
        },
      });
      let nextToken = response.data.siteDetailsByAssetownerID.nextToken;
      let sites = response.data.siteDetailsByAssetownerID.items;
      let sitess = sites.filter(
        (site) => site.LinkUsersAndSites.items.length > 0,
      );

      while (nextToken !== null) {
        const results = await client.graphql({
          query: mergedQueries.getSiteUsersFromLink,
          variables: {
            nextToken,
            assetownerID: LoginUserDetails.assetOwnerId,
            userdetailsID: LoginUserDetails.id,
          },
          authMode: "API_KEY",
        });
        nextToken = results.data.siteDetailsByAssetownerID.nextToken;
        const resultSites = results.data.siteDetailsByAssetownerID.items;
        sitess.push(
          ...resultSites.filter(
            (site) => site.LinkUsersAndSites.items.length > 0,
          ),
        );
      }

      if (sitess.length > 0) {
        setSiteDetails(sitess.filter((item) => item.status === "Active"));
        SiteData.setSiteData(sitess);
        localStorage.setItem("site", base64.encode(JSON.stringify(sitess)));
      } else {
        setSiteDetails([]);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setSiteDetails([]);
      setIsLoading(false);
    }
  }

  const onSubmit = async (data, e) => {
    if (id) {
      let taskCompletionLinkData;
      if (state.state !== null) {
        if (data.taskType === "Test") {
          taskCompletionLinkData = JSON.stringify([
            {
              site: taskCompletionArrayView[0].site,
              category: taskCompletionArrayView[0].category,
              distributionBoard: taskCompletionArrayView[0].distributionBoard,
              logbook: taskCompletionArrayView[0].logbook,
              company:
                data.company !== null
                  ? data.company
                  : taskCompletionArrayView[0].company,
              assets: taskCompletionArrayView[0].assets,
            },
          ]);
        } else {
          taskCompletionLinkData = JSON.stringify([
            {
              site: taskCompletionArrayView[0].site,
              category: taskCompletionArrayView[0].category,
              distributionBoard: taskCompletionArrayView[0].distributionBoard,
              logbook: taskCompletionArrayView[0].logbook,
              company:
                data.company !== null
                  ? data.company
                  : taskCompletionArrayView[0].company,
              test: taskCompletionArrayView[0].test,
              assetsTest: taskCompletionArrayView[0].assetsTest,
            },
          ]);
        }
        try {
          await client.graphql({
            query: mutations.updateTask,
            variables: {
              limit: limit,
              input: {
                id: id,
                dueDate: data.dueDate,
                taskCompletionLink: taskCompletionLinkData,
                taskStatus: data.taskStatus,
              },
            },
            authMode: "API_KEY",
          });
          toast.success("Updated Successfully!..", {
            position: toast.POSITION.TOP_CENTER,
          });
          e.target.reset();
          setSelectedItems([]);
          setSelectedItemsAsset([]);
        } catch (error) {
          console.log(error);
          toast.error("Error while Updating", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } else {
        try {
          await client.graphql({
            query: mutations.updateTask,
            variables: {
              limit: limit,
              input: {
                id: id,
                dueDate: data.dueDate,
                taskStatus: data.taskStatus,
              },
            },
            authMode: "API_KEY",
          });
          toast.success("Updated Successfully!..", {
            position: toast.POSITION.TOP_CENTER,
          });
          e.target.reset();
          setSelectedItems([]);
          setSelectedItemsAsset([]);
        } catch (error) {
          console.log(error);
          toast.error("Error while Updating", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    } else {
      const assetsTestRepair = selectedItems.map((item) =>
        item.assetsId ? item.assetsId : null,
      );
      const selectedItemsAssetIds = selectedItemsAsset.map((asset) => asset.id);
      const selectedItemsIds = selectedItems.map((asset) => asset.id);
      let taskCompletionLinkData;

      if (data.taskType === "Test") {
        taskCompletionLinkData = JSON.stringify([
          {
            site: siteId,
            category: data.category,
            distributionBoard: dbId,
            logbook: data.logbook,
            company: compID,
            assets: selectedItemsAssetIds,
          },
        ]);
      } else {
        taskCompletionLinkData = JSON.stringify([
          {
            site: siteId,
            category: data.category,
            distributionBoard: dbId,
            logbook: data.logbook,
            company: compID,
            test: selectedItemsIds,
            assetsTest: assetsTestRepair,
          },
        ]);
      }

      try {
        await client.graphql({
          query: mutations.createTask,
          variables: {
            input: {
              taskType: data.taskType,
              taskStatus: data.taskStatus,
              status: "Active",
              assignedDate: new Date().toISOString().split("T")[0],
              dueDate: data.dueDate,
              spcompanydetailsID: compID,
              sitedetailsID: siteId,
              taskCompletionLink: taskCompletionLinkData,
              assignedBy:
                LoginUserGroup !== "site_owner" && LoginUserGroup !== "spao"
                  ? LoginUserDetails.assetOwnerId
                  : LoginUserDetails.id,
            },
          },
          authMode: "API_KEY",
        });

        const targetAssetList =
          data.taskType === "Test" ? selectedItemsAssetIds : assetsTestRepair;
        targetAssetList.forEach(async (item, i) => {
          await sleep(Math.random() * i * 17);
          await client.graphql({
            query: mutations.updateAssets,
            variables: { input: { id: item, addedToTask: "intask" } },
            authMode: "API_KEY",
          });
        });

        toast.success("Successfully Added Task.", {
          position: toast.POSITION.TOP_CENTER,
        });
        e.target.reset();
        setSelectedItems([]);
        setSelectedItemsAsset([]);
        setSiteIdvalue("");
        setDBIdvalue("");
        setSiteId(null);
        setCatId(null);
        setDBId(null);
        setLogbookId(null);
        setSelectedItemsAssetfordistri([]);
        setSelectedItemsAssetforLogbook([]);
        setSelectedItemsAssetforViceversa([]);
        setAssetSiteCatFilter([]);
        setAssetsDemo([]);
        setSelectedTaskType("");
        setRepairData([]);
        setRepairDemo([]);
        setLogbook(false);
        setDB(false);
        setRepairDataSiteCat([]);
        setIsAllSelectedRepair(false);
        setIsAllSelected(false);
        setExistingTask([]);

        if (data.company) {
          const response = await client.graphql({
            query: queries.listSPCompanyDetails,
            variables: { filter: { id: { eq: data.company } }, limit: limit },
            authMode: "API_KEY",
          });
          const company = response.data.listSPCompanyDetails.items;
          const email = company[0].email;
          const emailData = {
            assignedBy: ao.find((item) => item.id === LoginUserDetails.id)
              ? `${ao.find((item) => item.id === LoginUserDetails.id).fname} ${ao.find((item) => item.id === LoginUserDetails.id).lname}`
              : "",
            TaskType: data.taskType,
            TaskStatus: data.taskStatus,
            site: getSiteUnitNumber(siteId),
            category: getCategory(data.category),
            distributionBoard: getDBName(dbId),
            logbook: logbookname(data.logbook),
            company: company[0].companyName,
            DueDate: moment(data.dueDate).format("DD/MM/YYYY"),
          };
          sendEmail(email, emailData);
        }
      } catch (error) {
        console.log(error);
        toast.error("Error While Adding Task: " + error, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  useEffect(() => {
    const getspsites = async () => {
      try {
        const result = await client.graphql({
          query: queries.listUserDetails,
          variables: {
            filter: { companyDetailsId: { eq: compID } },
            limit: limit,
          },
          authMode: "API_KEY",
        });
        const spp = result.data.listUserDetails.items;
        let assets = [];
        for (const item of spp) {
          let nextToken = "";
          let linkResult = await client.graphql({
            query: queries.linkUsersAndSitesByUserdetailsID,
            variables: {
              userdetailsID: item.id,
              filter: { status: { eq: "Active" } },
              limit: limit,
            },
            authMode: "API_KEY",
          });
          let assetDatas =
            linkResult.data.linkUsersAndSitesByUserdetailsID.items;
          nextToken =
            linkResult.data.linkUsersAndSitesByUserdetailsID.nextToken;
          if (assetDatas.length > 0) assets.push(assetDatas);

          while (nextToken !== null) {
            let results = await client.graphql({
              query: queries.linkUsersAndSitesByUserdetailsID,
              variables: {
                userdetailsID: item.id,
                filter: { status: { eq: "Active" } },
                limit: limit,
                nextToken,
              },
              authMode: "API_KEY",
            });
            nextToken = results.data.linkUsersAndSitesByUserdetailsID.nextToken;
            if (
              results.data.linkUsersAndSitesByUserdetailsID.items.length > 0
            ) {
              assets.push(results.data.linkUsersAndSitesByUserdetailsID.items);
            }
          }
        }
        if (assets.length > 0) {
          const mergeAssets = assets.flat(1);
          const sitesfilter = siteDetails.filter((item) =>
            mergeAssets.find((user) => user.sitedetailsID === item?.id),
          );
          setSiteFilter(sitesfilter.filter((item) => item.status === "Active"));
        }
      } catch (error) {
        console.log(error);
        setSiteFilter([]);
      }
    };
    if (compID.length > 0) getspsites();
  }, [compID]);

  const handleDropdownChange = (event) => {
    setCompId(event.target.value);
  };

  const optionsSites = [
    { value: "", label: "Select Site" },
    ...siteFilter.map((item) => ({
      value: item.id,
      label: `${item.siteName || ""} (${item.unitNumber || ""})`,
    })),
  ];

  const optionsDB = [
    { value: "", label: "Select Distribution Board" },
    ...distributionBoxFilter.map((item) => ({
      value: item.id,
      label: item.distributionBoxName,
    })),
  ];

  const handleSite = (event) => {
    setSiteId(event.value);
    setSiteIdvalue(event);
    setCatId([]);
    setSelectedItems([]);
    setSelectedItemsAsset([]);
    setIsAllSelectedRepair(false);
    setIsAllSelected(false);
    setDBIdvalue("");
    setDBId(null);
    setLogbookId([]);
    setSelectedItemsAssetfordistri([]);
    setSelectedItemsAssetforLogbook([]);
    setSelectedItemsAssetforViceversa([]);
    setLogbook(false);
    setDB(false);
    setAssetSiteCatFilter([]);
    setRepairData([]);
    setRepairDemo([]);
    setAssetsDemo([]);
  };

  const handleDB = (event) => {
    setDBId(event.value);
    setDBIdvalue(event);
  };

  const handleCategoryChange = async (event) => {
    const categoryId = event.target.value;
    setCatId(categoryId);
    setSelectedItems([]);
    setSelectedItemsAsset([]);
    setIsAllSelectedRepair(false);
    setIsAllSelected(false);
    setDBIdvalue("");
    setDBId(null);
    setLogbookId("");
    setSelectedItemsAssetfordistri([]);
    setSelectedItemsAssetforLogbook([]);
    setSelectedItemsAssetforViceversa([]);
    setLogbook(false);
    setDB(false);

    try {
      const result = await client.graphql({
        query: queries.tasksBySitedetailsID,
        variables: {
          sitedetailsID: siteId,
          filter: {
            status: { eq: "Active" },
            taskType: { eq: selectedTaskType },
          },
          limit: limit,
        },
        authMode: "API_KEY",
      });

      const items = result.data.tasksBySitedetailsID.items || [];
      const twoMonthsAgo = new Date();
      twoMonthsAgo.setMonth(twoMonthsAgo.getMonth() - 2);

      const siteData = items.filter(
        (item) => new Date(item.createdAt) >= twoMonthsAgo,
      );
      const filteredTestdata = siteData.filter((sp) => {
        const link = JSON.parse(sp.taskCompletionLink || "[]");
        return link[0]?.category === categoryId;
      });

      const sortedData = filteredTestdata.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
      );

      if (sortedData.length > 0) {
        setExistingTask(sortedData);
        setShowPopup(true);
        setIsAssetLocked(true);
        setAllowSubmit(false);
      } else {
        setExistingTask([]);
        setIsAssetLocked(false);
        setAllowSubmit(true);
      }
    } catch (error) {
      console.log("Error fetching tasks:", error);
    }
  };

  const handleContinue = () => {
    setShowPopup(false);
    setIsAssetLocked(false);
    setAllowSubmit(true);
  };

  const handleCancel = () => {
    setShowPopup(false);
    setAllowSubmit(false);
    setCatId("");
    setSiteId([]);
    setSiteIdvalue("");
    setIsAssetLocked(false);
    setExistingTask([]);
    setAssetSiteCatFilter([]);
    setSelectedItems([]);
    setSelectedItemsAsset([]);
    setDBIdvalue("");
    setDBId(null);
    setLogbookId(null);
    setSelectedItemsAssetfordistri([]);
    setSelectedItemsAssetforLogbook([]);
    setSelectedItemsAssetforViceversa([]);
    setAssetsDemo([]);
    setRepairData([]);
    setRepairDemo([]);
    setLogbook(false);
    setDB(false);
    setRepairDataSiteCat([]);
    setIsAllSelectedRepair(false);
    setIsAllSelected(false);
  };

  const handleTaskTypeChange = (e) => {
    setSelectedTaskType(e.target.value);
    setExistingTask([]);
  };

  return (
    <Fragment>
      <Container fluid={true}>
        <Row>
          <Col md="12" className="project-list">
            <Card className="custom-card">
              <CardBody>
                <H4 attrH4={{ className: "taskHead" }}>
                  {view
                    ? "View Tasks"
                    : taskList.taskStatus
                      ? "Edit Tasks"
                      : "Add Tasks"}
                </H4>
                <Form
                  className="needs-validation"
                  noValidate=""
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <Row>
                    <Col md="6 mb-3">
                      <Label>Task Type</Label>
                      <select
                        className="form-select"
                        name="taskType"
                        value={selectedTaskType}
                        {...register("taskType", {
                          required: !taskList.taskType,
                        })}
                        onChange={handleTaskTypeChange}
                        disabled={!!taskList.taskType}
                      >
                        {taskList.taskType ? (
                          <option value={taskList.taskType}>
                            {taskList.taskType}
                          </option>
                        ) : (
                          <>
                            <option value="">Select Task Type</option>
                            <option value="Test">Test</option>
                            <option value="Repair">Repair</option>
                            <option value="Replace">Replace</option>
                          </>
                        )}
                      </select>
                      <span>{errors.taskType && "Task Type is required"}</span>
                    </Col>
                    <Col md="6 mb-3">
                      <Label>Task Status</Label>
                      <select
                        className="form-control"
                        name="taskStatus"
                        {...register("taskStatus", {
                          required: !taskList.taskStatus,
                        })}
                        defaultValue={
                          taskList.taskStatus ? taskList.taskStatus : "Assigned"
                        }
                      >
                        {taskList.taskStatus && (
                          <option value={taskList.taskStatus}>
                            {taskList.taskStatus}
                          </option>
                        )}
                        <option value="Assigned">Assigned</option>
                        <option value="Hold">Hold</option>
                        {!taskList.taskStatus && (
                          <>
                            <option value="Pending">Pending</option>
                            <option value="Completed">Completed</option>
                          </>
                        )}
                      </select>
                      <span>
                        {errors.taskStatus && "Task Status is required"}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6 mb-3">
                      <Label>Due Date</Label>
                      <input
                        className="form-control"
                        name="dueDate"
                        type="date"
                        {...register("dueDate", { required: true })}
                      />
                      <span>{errors.dueDate && "Due Date is required"}</span>
                    </Col>
                    <Col md="6 mb-3">
                      <Label>Service Provider Company</Label>
                      <select
                        className="form-select"
                        name="company"
                        {...register("company", {
                          required: !taskList.taskCompletionLink,
                        })}
                        onChange={handleDropdownChange}
                        disabled={
                          state.state && state.state.purpose === "hold"
                            ? false
                            : !!taskList.taskCompletionLink
                        }
                      >
                        {state.state && state.state.purpose === "hold" ? (
                          <>
                            {taskList.taskCompletionLink &&
                              taskList.taskCompletionLink[0] && (
                                <option
                                  value={taskCompletionArrayView[0].company}
                                >
                                  {getCompany(
                                    taskCompletionArrayView[0].company,
                                  )}
                                </option>
                              )}
                            {spCompany.map((item) => (
                              <option
                                value={
                                  LoginUserGroup === "site_owner"
                                    ? item.spcomapnyId
                                    : item.id
                                }
                                key={
                                  LoginUserGroup === "site_owner"
                                    ? item.spcomapnyId
                                    : item.id
                                }
                              >
                                {item.companyName}
                              </option>
                            ))}
                          </>
                        ) : taskList.taskCompletionLink ? (
                          <option
                            value={taskList.taskCompletionLink[0]["company"]}
                          >
                            {getCompany(taskCompletionArrayView[0].company)}
                          </option>
                        ) : (
                          <>
                            <option value="">Select Company</option>
                            {spCompany.map((item) => (
                              <option
                                value={
                                  LoginUserGroup === "site_owner"
                                    ? item.spcomapnyId
                                    : item.id
                                }
                                key={
                                  LoginUserGroup === "site_owner"
                                    ? item.spcomapnyId
                                    : item.id
                                }
                              >
                                {item.companyName}
                              </option>
                            ))}
                          </>
                        )}
                      </select>
                      <span>{errors.company && "Company is required"}</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="3 mb-3">
                      <Label>Choose Sites</Label>
                      {taskList.taskCompletionLink &&
                      taskList.taskCompletionLink.length > 0 ? (
                        <select
                          className="form-select"
                          name="site"
                          {...register("site", { required: false })}
                          onChange={(event) => setSiteId(event.target.value)}
                          disabled={true}
                        >
                          {taskList.taskCompletionLink.length > 0 && (
                            <option
                              value={taskList.taskCompletionLink[0]["site"]}
                            >
                              {getSiteUnitNumber(
                                taskCompletionArrayView[0].site,
                              )}
                            </option>
                          )}
                        </select>
                      ) : (
                        <Select
                          options={optionsSites}
                          isSearchable={true}
                          value={siteIdvalue}
                          placeholder="Select Sites"
                          onChange={handleSite}
                          name="site"
                          menuPlacement="auto"
                          menuPosition="fixed"
                        />
                      )}
                      <span>{errors.site && "Site is required"}</span>
                    </Col>
                    <Col md="3 mb-3">
                      <Label>Choose Category</Label>
                      <select
                        className="form-select"
                        value={catId || ""}
                        name="category"
                        {...register("category", {
                          required: !taskList.taskCompletionLink,
                        })}
                        onChange={handleCategoryChange}
                        disabled={!!taskList.taskCompletionLink}
                      >
                        {taskList.taskCompletionLink &&
                        taskList.taskCompletionLink.length > 0 ? (
                          <option
                            value={taskList.taskCompletionLink[0]["category"]}
                          >
                            {getCategory(taskCompletionArrayView[0].category)}
                          </option>
                        ) : (
                          <>
                            <option value="">Select Category</option>
                            {categoryDetails.map((item) => (
                              <option value={item.id} key={item.id}>
                                {item.categoryName}
                              </option>
                            ))}
                          </>
                        )}
                      </select>
                      <span>{errors.category && "Category is required"}</span>
                    </Col>
                    <Col md="3 mb-3">
                      <Label>Choose Logbook</Label>
                      <select
                        className="form-select"
                        name="logbook"
                        value={logbookId || ""}
                        {...register("logbook", { required: false })}
                        onChange={(event) => setLogbookId(event.target.value)}
                        disabled={!!taskList.taskCompletionLink}
                      >
                        {taskList.taskCompletionLink &&
                        taskList.taskCompletionLink.length > 0 ? (
                          <option
                            value={taskList.taskCompletionLink[0]["logbook"]}
                          >
                            {logbookname(taskCompletionArrayView[0].logbook)}
                          </option>
                        ) : (
                          <>
                            <option value="">Select Logbook</option>
                            {logbookDataSiteFilter.map((item) => (
                              <option value={item.id} key={item.id}>
                                {item.logbookName}
                              </option>
                            ))}
                          </>
                        )}
                      </select>
                    </Col>
                    <Col md="3 mb-3">
                      <Label>Choose Distribution Board</Label>
                      {taskList.taskCompletionLink &&
                      taskList.taskCompletionLink.length > 0 ? (
                        <select
                          className="form-select"
                          name="distributionBoard"
                          {...register("distributionBoard", {
                            required: false,
                          })}
                          onChange={(event) => setDBId(event.target.value)}
                          disabled={true}
                        >
                          {taskList.taskCompletionLink.length > 0 && (
                            <option
                              value={
                                taskList.taskCompletionLink[0][
                                  "distributionBoard"
                                ]
                              }
                            >
                              {getDBName(
                                taskCompletionArrayView[0].distributionBoard,
                              )}
                            </option>
                          )}
                        </select>
                      ) : (
                        <Select
                          options={optionsDB}
                          isSearchable={true}
                          value={dbIdvalue}
                          placeholder="Select Distribution Boards"
                          onChange={handleDB}
                          name="DB"
                          menuPlacement="auto"
                          menuPosition="fixed"
                        />
                      )}
                    </Col>
                  </Row>
                  <Row>
                    {existingTask.length > 0 && (
                      <Col>
                        <a
                          href="#view-existing"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowPopup(true);
                          }}
                        >
                          View Existing Task Details
                        </a>
                      </Col>
                    )}
                  </Row>
                  <Row>
                    {taskList.taskCompletionLink &&
                      taskList.taskCompletionLink.length > 0 && (
                        <>
                          {!!taskList.dueDate &&
                            taskCompletionArrayView[0].assets &&
                            taskCompletionArrayView[0].assets.length > 0 &&
                            taskCompletionArrayView[0].assets[0].length > 0 && (
                              <Row>
                                <div className="table-responsive">
                                  <Table className="table-striped table-de">
                                    <thead className="custom-table-head">
                                      <tr>
                                        <th scope="col">Added On</th>
                                        <th scope="col">Fitting Number</th>
                                        <th scope="col">Asset Model</th>
                                        <th scope="col">Asset Type</th>
                                        <th scope="col">Asset Location</th>
                                        <th scope="col">Installed On</th>
                                        <th scope="col">Description</th>
                                      </tr>
                                    </thead>
                                    <tbody className="trhover">
                                      {viewAssets.length > 0 ? (
                                        taskCompletionArrayView[0].assets.map(
                                          (assetId) => {
                                            const matchingAsset =
                                              viewAssets.find(
                                                (item) => item.id === assetId,
                                              );
                                            return matchingAsset ? (
                                              <tr key={matchingAsset.id}>
                                                <td>
                                                  {moment(
                                                    matchingAsset.createdAt,
                                                  ).format("DD/MM/YYYY")}
                                                </td>
                                                <td>
                                                  {matchingAsset.fittingNumber}
                                                </td>
                                                <td>
                                                  {matchingAsset.assetModel}
                                                </td>
                                                <td>
                                                  {matchingAsset.assetType}
                                                </td>
                                                <td>
                                                  {matchingAsset.assetLocation}
                                                </td>
                                                <td>
                                                  {moment(
                                                    matchingAsset.installedOn,
                                                  ).format("DD/MM/YYYY")}
                                                </td>
                                                <td>
                                                  {
                                                    matchingAsset.assetDescription
                                                  }
                                                </td>
                                              </tr>
                                            ) : null;
                                          },
                                        )
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan="7"
                                            className="text-center"
                                          >
                                            No Assets Available.
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </Table>
                                </div>
                              </Row>
                            )}
                          {taskCompletionArrayView[0].test && (
                            <div className="table-responsive">
                              <Table className="table-striped table-de">
                                <thead className="custom-table-head">
                                  <tr>
                                    <th scope="col">Added On</th>
                                    <th scope="col">Fitting Number</th>
                                    <th scope="col">Test On</th>
                                    <th scope="col">Test Result</th>
                                    <th scope="col">Next Test Schedule</th>
                                    <th scope="col">Technician</th>
                                  </tr>
                                </thead>
                                <tbody className="trhover">
                                  {isLoadingtest ? (
                                    <tr>
                                      <td colSpan="6" className="text-center">
                                        <LoadingSpinner />
                                      </td>
                                    </tr>
                                  ) : testView.length > 0 ? (
                                    taskCompletionArrayView[0].test.map(
                                      (testId) => {
                                        const matchingTest = testView.find(
                                          (item) => item.id === testId,
                                        );
                                        return matchingTest ? (
                                          <tr key={matchingTest.id}>
                                            <td>
                                              {moment(
                                                matchingTest.createdAt,
                                              ).format("DD/MM/YYYY")}
                                            </td>
                                            <td>
                                              {isLoading
                                                ? "Loading..."
                                                : assetData[
                                                    matchingTest.assetsID
                                                  ] || "Not Found"}
                                            </td>
                                            <td>
                                              {moment(
                                                matchingTest.testOn,
                                              ).format("DD/MM/YYYY")}
                                            </td>
                                            <td>{matchingTest.testResult}</td>
                                            <td>
                                              {moment(
                                                matchingTest.nextTestSchedule,
                                              ).format("DD/MM/YYYY")}
                                            </td>
                                            <td>
                                              {getTechnicianName(
                                                matchingTest.technician[0],
                                              )}
                                            </td>
                                          </tr>
                                        ) : null;
                                      },
                                    )
                                  ) : (
                                    <tr>
                                      <td colSpan="6" className="text-center">
                                        No Test Data Available.
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          )}
                        </>
                      )}
                    {!taskList.taskCompletionLink && (
                      <>
                        {(selectedTaskType === "Test" ||
                          selectedTaskType === "") && (
                          <>
                            <div className="table-responsive">
                              <Table className="table-striped table-de">
                                <thead className="custom-table-head">
                                  <tr>
                                    <th scope="col">
                                      <input
                                        type="checkbox"
                                        checked={isAllSelected}
                                        onChange={(event) =>
                                          handleCheckboxAssetChange(
                                            event,
                                            "selectAll",
                                          )
                                        }
                                      />
                                      Select All
                                    </th>
                                    <th scope="col">Added On</th>
                                    <th scope="col">Fitting Number</th>
                                    <th scope="col">Asset Model</th>
                                    <th scope="col">Asset Type</th>
                                    <th scope="col">Asset Location</th>
                                    <th scope="col">Installed On</th>
                                    <th scope="col">Description</th>
                                  </tr>
                                </thead>
                                <tbody className="trhover">
                                  {isLoading ? (
                                    <tr>
                                      <td colSpan="8" className="text-center">
                                        <LoadingSpinner />
                                      </td>
                                    </tr>
                                  ) : assetSiteCatFilter.length > 0 ? (
                                    assetSiteCatFilter.map((item) => (
                                      <tr key={item.id}>
                                        <td>
                                          <input
                                            type="checkbox"
                                            name="completionLink"
                                            checked={
                                              isAllSelected ||
                                              selectedItemsAsset.includes(item)
                                            }
                                            onChange={(event) =>
                                              handleCheckboxAssetChange(
                                                event,
                                                item,
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          {moment(item.createdAt).format(
                                            "DD/MM/YYYY",
                                          )}
                                        </td>
                                        <td>{item.fittingNumber}</td>
                                        <td>{item.assetModel}</td>
                                        <td>{item.assetType}</td>
                                        <td>{item.assetLocation}</td>
                                        <td>
                                          {moment(item.installedOn).format(
                                            "DD/MM/YYYY",
                                          )}
                                        </td>
                                        <td>{item.assetDescription}</td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="8" className="text-center">
                                        No Assets Available.
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </div>
                            <CardFooter className="row">
                              <Pagination
                                className="p-t-10"
                                pageSize={countPerPage}
                                onChange={updatePage2}
                                current={currentPage1}
                                total={assetsDemo.length}
                                showTotal={(total, range) =>
                                  `${range[0]} - ${range[1]} of ${total} items`
                                }
                              />
                            </CardFooter>
                          </>
                        )}
                        {selectedTaskType !== "Test" &&
                          selectedTaskType !== "" && (
                            <>
                              <div className="table-responsive">
                                <Table className="table-striped table-de">
                                  <thead className="custom-table-head">
                                    <tr>
                                      <th scope="col">
                                        <input
                                          type="checkbox"
                                          checked={isAllSelectedRepair}
                                          onChange={(event) =>
                                            handleCheckboxChange(
                                              event,
                                              "selectAll",
                                            )
                                          }
                                        />
                                        Select All
                                      </th>
                                      <th scope="col">Added On</th>
                                      <th scope="col">Fitting Number</th>
                                      <th scope="col">Test On</th>
                                      <th scope="col">Test Result</th>
                                      <th scope="col">Next Test Schedule</th>
                                      <th scope="col">Technician</th>
                                    </tr>
                                  </thead>
                                  <tbody className="trhover">
                                    {isLoadingRepair ? (
                                      <tr>
                                        <td colSpan="7" className="text-center">
                                          <LoadingSpinner />
                                        </td>
                                      </tr>
                                    ) : RepairData.length > 0 ? (
                                      RepairData.map((item) => (
                                        <tr key={item.id}>
                                          <td>
                                            <input
                                              type="checkbox"
                                              name="completionLink"
                                              checked={
                                                isAllSelectedRepair ||
                                                selectedItems.includes(item)
                                              }
                                              onChange={(event) =>
                                                handleCheckboxChange(
                                                  event,
                                                  item,
                                                )
                                              }
                                            />
                                          </td>
                                          <td>
                                            {moment(item.createdAt).format(
                                              "DD/MM/YYYY",
                                            )}
                                          </td>
                                          <td>{item.assetsID}</td>
                                          <td>
                                            {moment(item.testOn).format(
                                              "DD/MM/YYYY",
                                            )}
                                          </td>
                                          <td>{item.testResult}</td>
                                          <td>
                                            {item.nextTestSchedule
                                              ? moment(
                                                  item.nextTestSchedule,
                                                ).format("DD/MM/YYYY")
                                              : "-"}
                                          </td>
                                          <td>
                                            {item.technician &&
                                              getTechnicianName(
                                                item.technician[0],
                                              )}
                                          </td>
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan="7" className="text-center">
                                          No Test Data Available.
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                              <CardFooter className="row">
                                <Pagination
                                  className="p-t-10"
                                  pageSize={countPerPage}
                                  onChange={updatePage1}
                                  current={currentPage}
                                  total={repairDemo.length}
                                  showTotal={(total, range) =>
                                    `${range[0]} - ${range[1]} of ${total} items`
                                  }
                                />
                              </CardFooter>
                            </>
                          )}
                      </>
                    )}
                  </Row>
                  <Row>
                    <Col md="6"></Col>
                    <Col md="6" className="text-end">
                      <Btn attrBtn={{ color: "danger", onClick: cancelForm }}>
                        Cancel
                      </Btn>
                      <Btn
                        attrBtn={{ color: "primary", disabled: !allowSubmit }}
                      >
                        {!id ? "Submit" : "Update"}
                      </Btn>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>

            <Modal show={showPopup} centered className="overlayEffect">
              <Modal.Header>
                <Modal.Title>Existing Task Found</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>
                  An active task already exists for the selected Site and
                  Category. Please review the existing task before creating a
                  new one.
                </p>
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Added On</th>
                      <th>Task Type</th>
                      <th>Status</th>
                      <th>Due Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {existingTask.map((task) => (
                      <tr key={task.id}>
                        <td>
                          {task.createdAt
                            ? moment(task.createdAt).format("DD/MM/YYYY")
                            : "-"}
                        </td>
                        <td>{task.taskType}</td>
                        <td>{task.taskStatus}</td>
                        <td>
                          {task.dueDate
                            ? moment(task.dueDate).format("DD/MM/YYYY")
                            : "-"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={handleCancel}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleContinue}>
                  Continue to create Task
                </Button>
              </Modal.Footer>
            </Modal>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default AddTasksContain;
